__turbopack_context__.v({
  "leaves": "Can00a_leaves",
  "sway": "Can00a_sway",
  "trunk": "Can00a_trunk",
});
